import cn from 'classnames'
import { useState } from 'react'
import { CompatibleLink } from 'src/components/CompatibleLink/CompatibleLink'
import { useGetTopicsForHeaderQuery } from 'src/graphql/generated/hooks'

interface CategoryListProps {
  listCategory: string[]
  className?: string
  /** When true, wrapper uses display:contents so chips share one flex row with siblings (e.g. custom tags). */
  mergeInline?: boolean
}

const CategoryList: React.FC<CategoryListProps> = ({ listCategory, className, mergeInline = false }) => {
  const [active, setActive] = useState(false)
  const handleClick = () => {
    setActive(!active)
  }

  const { data: topics } = useGetTopicsForHeaderQuery({ fetchPolicy: 'cache-first' })

  const findTopic = (subTopicName: string) => {
    const find = topics?.topics.filter((item: any) => {
      const subTopics = item?.subTopics
      return subTopics?.some((subTopic: any) => subTopic?.name === subTopicName)
    })

    return find && find.length > 0
      ? `/topics/${find[0]?.slug}/${
          find[0]?.subTopics?.filter((item: any) => item?.name === subTopicName)[0]?.slug as string
        }`
      : ''
  }

  return (
    <div className={cn(mergeInline ? 'contents' : 'flex flex-wrap items-center', className)}>
      {listCategory.map((item: string, index: number) => {
        if (index < 4) {
          return (
            <CompatibleLink
              href={findTopic(item)}
              key={index}
              className="flex bg-clouds text-textdark text-[0.8125rem] font-primary font-medium items-center text-center rounded-[15px] mt-1.5 mr-4 px-[14px] h-[30px]"
            >
              {item}
            </CompatibleLink>
          )
        } else {
          if (active) {
            return (
              <CompatibleLink
                href={findTopic(item)}
                key={index}
                className="flex bg-clouds text-textdark text-[0.8125rem] font-primary font-medium items-center text-center rounded-[15px] mt-1.5 mr-4 px-[14px] h-[30px]"
              >
                {item}
              </CompatibleLink>
            )
          } else {
            return <div key={index}></div>
          }
        }
      })}
      {!active && listCategory.length > 4 && (
        <div
          className="h-[1.25rem] text-textdark text-[0.8125rem] font-primary font-medium mt-1.5"
          onClick={handleClick}
        >
          +{listCategory.length - 4} {listCategory.length - 4 === 1 ? 'more category' : 'more categories'}
        </div>
      )}
    </div>
  )
}

export default CategoryList
